
import { configStore } from "@/store/store";
import { BuilderElement } from "@/types/elements";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import RawIcon from "@/components/UI/RawIcon.vue";
import { iconNames } from "@/lib/icons/icons";

@Component({
  components: { RawIcon }
})
export default class WebsiteDialog extends Vue {
  elementIconIsLocal(x: string) {
    return iconNames.find(iconName => iconName === x);
  }

  isOpen = false;

  get elementCategories() {
    const elements = Object.values(configStore.elements) as BuilderElement[];

    return configStore.builderElementCategories
      .map(category => {
        return {
          categoryLabel: category.label,
          elements: elements
            .filter(element => element.experimental !== true)
            .filter(
              element =>
                !element.addPanelRules || !element.addPanelRules.alwaysHide
            )
            .filter(element => element.category === category.slug)
            .map(element => {
              return {
                element: element.name,
                icon: element.uiIcon
              };
            })
            .sort((a, b) => a.element.localeCompare(b.element))
        };
      })
      .filter(c => c.elements.length !== 0);
  }
}
